export default __webpack_public_path__ + "static/media/funeral.a763dd13.mp4";